
<template>
    <div class="productaward row" v-for="item in product.ProductAwardsLocalized" :key="item" v-bind:class="{'productaward-linked': item.URL != null }">
        <a href="javascript:void(0)" v-on:click="runAwardClick(item.URL, item.OpenInNewWindow)" title="">
            <div class="image" v-if="item.CloudinaryImage == null" :style="{ 'background-image': 'url('+ item.Image + ')' }" :alt="item.ImageAltText">
                <img :src="cdn + '/Images/Shared/overlay.png'" :alt="item.ImageAltText"/>
            </div>
            <div class="image" v-else :style="{ 'background-image': 'url('+ item.CloudinaryImage.ImageUrlSmall + ')' }"  :alt="item.ImageAltText">
                <img :src="cdn + '/Images/Shared/overlay.png'" :alt="item.ImageAltText"/>
            </div>
            <div class="quote">
                <div class="outer-wrapper">
                    <div class="inner-wrapper">
                        <h5>{{ item.Quote }} </h5>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>


<script>
    import vueStore from '../../store/store.js';
    
    export default {
        data: function () {
            return {
                cdn: window.cdn,               
            }
        },
        mounted() {
            //console.log('mounted from product-awards');
        },
        methods: {
            runAwardClick(awardUrl, openInNewWindow) {
                if (awardUrl != undefined && awardUrl.length > 0) {
                    // track click 
                    window.trackEventGlobalAndLocal('Award', 'Click', awardUrl);
                    // go to url
                    if (openInNewWindow) {
                        window.open(awardUrl, '_blank');
                    } else {
                        window.open(awardUrl, '_self');
                    }
                }
            }

        },
        computed: {
            product() {
                return vueStore.state.product
            },           
        },
        created() {
            //this.interfaceTexts = JSON.parse(document.getElementById('vue-product-images').dataset.interfacetexts);
        }
    }
</script>
